import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface CenteredSpinnerProps {
  py?: number;
  size?: number;
}

export default function CenteredSpinner({ py = 4, size }: CenteredSpinnerProps) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py }}>
      <CircularProgress size={size} />
    </Box>
  );
}
